import {
  FETCH_CAMPAIGNS_SETTINGS,
  SAVE_NOTIFY_MANAGER_DEFAULTS,
  SP_GENERATION_POLLING_ASYNC,
  SUBMIT_UPSELL_SEEN_INDICATION,
} from './constants'

export const submitUpsellSeenIndication = () => ({
  type: SUBMIT_UPSELL_SEEN_INDICATION.INITIATE,
})
export const submitUpsellSeenIndicationSuccess = () => ({
  type: SUBMIT_UPSELL_SEEN_INDICATION.SUCCESS,
})
export const submitUpsellSeenIndicationError = (error) => ({
  type: SUBMIT_UPSELL_SEEN_INDICATION.ERROR,
  error,
})

export const submitFetchCampaignsSettings = () => ({
  type: FETCH_CAMPAIGNS_SETTINGS.INITIATE,
})
export const submitFetchCampaignsSettingsSuccess = (data) => ({
  type: FETCH_CAMPAIGNS_SETTINGS.SUCCESS,
  payload: { data },
})

export const submitFetchCampaignsSettingsCancel = () => ({
  type: FETCH_CAMPAIGNS_SETTINGS.CANCEL,
})

export const submitFetchCampaignsSettingsError = (error) => ({
  type: FETCH_CAMPAIGNS_SETTINGS.ERROR,
  error,
})

export const saveNotifyManagerDefaults = (payload) => SAVE_NOTIFY_MANAGER_DEFAULTS.initiate(payload)
export const saveNotifyManagerDefaultsSuccess = (payload) =>
  SAVE_NOTIFY_MANAGER_DEFAULTS.onSuccess(payload)
export const saveNotifyManagerDefaultsError = (error) => SAVE_NOTIFY_MANAGER_DEFAULTS.onError(error)
export const saveNotifyManagerDefaultsCancel = () => SAVE_NOTIFY_MANAGER_DEFAULTS.cancel()

export const spGenerationPolling = () => ({
  type: SP_GENERATION_POLLING_ASYNC.INITIATE,
})
export const spGenerationPollingSuccess = () => ({
  type: SP_GENERATION_POLLING_ASYNC.SUCCESS,
})
export const spGenerationPollingError = (error) => ({
  type: SP_GENERATION_POLLING_ASYNC.ERROR,
  error,
})
